import {browserStorageKey} from '../constants/browserStorageKey';

const IS_PRODUCTION_BUILD = process.env.NODE_ENV === 'production';

/**
 * Local-dev only: name of the backend git worktree all API traffic should be routed to, or `null`
 * when requests should hit the main backend app as before.
 *
 * The backend monorepo serves every worktree as its own app on the shared local stack and picks
 * the target from the `X-Worktree` header (no header = main). The name is read per request rather
 * than baked into the bundle, so switching worktrees needs no rebuild — see
 * `applyWorktreeOverrideFromUrl` for how it gets set.
 */
export function getWorktreeName(): string | null {
  if (IS_PRODUCTION_BUILD || typeof localStorage === 'undefined') {
    return null;
  }

  const worktreeName = localStorage.getItem(browserStorageKey.WORKTREE_NAME);

  return worktreeName === '' ? null : worktreeName;
}
